/**
 * Standard filter chips — the single chip style used across the Platform Admin
 * dashboard. options: [{ value, label, count? }]
 */
const FilterChips = ({ options, value, onChange, testIdPrefix = 'filter' }) => (
  <div className="flex flex-wrap gap-2">
    {options.map((opt) => (
      <button
        key={opt.value}
        onClick={() => onChange(opt.value)}
        data-testid={`${testIdPrefix}-${String(opt.value).toLowerCase().replace(/_/g, '-')}`}
        className={`px-3 py-1.5 rounded-full text-xs font-medium transition-all ${
          value === opt.value
            ? 'bg-blue-50 text-blue-700 border border-blue-200'
            : 'bg-gray-100 text-gray-600 hover:bg-gray-200 border border-transparent'
        }`}
      >
        {opt.label}
        {opt.count !== undefined ? ` (${opt.count})` : ''}
      </button>
    ))}
  </div>
);

export default FilterChips;
